import { xApplyFunctionStr } from 'ml-spectra-processing';
/**
 * Filter that allows to
 * @param data
 * @param options
 */
export function xFunction(data, options = {}) {
    return {
        data: {
            x: xApplyFunctionStr(data.x, {
                variableLabel: 'x',
                fctString: options.function,
            }),
            y: data.y,
        },
    };
}
//# sourceMappingURL=xFunction.js.map